function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "meditating_svg__a",
  x1: 890.27,
  y1: 819.43,
  x2: 890.27,
  y2: 453.22,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M648.11 544.22a23.27 23.27 0 01-2.11 3.25q-10.5-7.35-21.38-14.47l.47-.93a20.53 20.53 0 017.27-7.92c4-2.46 8.51-3 12.22-1s5.78 6 6 10.67a20.6 20.6 0 01-2.47 10.4z",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 717.85,
  cy: 577.53,
  rx: 17.05,
  ry: 13.02,
  transform: "rotate(-62.09 634.155 608.042)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 727.6,
  cy: 559.12,
  rx: 17.05,
  ry: 13.02,
  transform: "rotate(-62.09 643.905 589.626)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 737.35,
  cy: 540.71,
  rx: 17.05,
  ry: 13.02,
  transform: "rotate(-62.09 653.663 571.215)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 747.1,
  cy: 522.3,
  rx: 17.05,
  ry: 13.02,
  transform: "rotate(-62.09 663.408 552.808)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M699.25 315.72a61.7 61.7 0 01-1-8.58l32.92 11.08-32.83-17.08a62.45 62.45 0 0122.08-44.23l31.81 46-24.73-51.2a62.37 62.37 0 1158.36 109.89 62.4 62.4 0 011 13.39l-50-.4 49.28 8.12a62.37 62.37 0 01-36.29 47.05 62.37 62.37 0 11-86.65-45.89 62.39 62.39 0 0136.1-68.15z",
  fill: "#3fa7f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M779.64 401.93a62.14 62.14 0 01-29.84 27.83 62.37 62.37 0 11-86.65-45.89c-2.42-13.29 119.77 11.87 116.49 18.06z",
  opacity: 0.1
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M216.98 658.89a43.27 43.27 0 002.39 7.05q23.11-8.85 46.75-17c-.14-.64-.28-1.3-.44-2a39.53 39.53 0 00-9.83-18.22c-6.29-6.48-14.45-9.64-22.3-7.72s-13.63 8.47-16.24 17.09a39.55 39.55 0 00-.33 20.8z",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 303.33,
  cy: 671.75,
  rx: 25.07,
  ry: 32.81,
  transform: "rotate(-13.72 27.297 939.799)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 293.82,
  cy: 632.78,
  rx: 25.07,
  ry: 32.81,
  transform: "rotate(-13.72 17.812 900.88)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 284.31,
  cy: 593.82,
  rx: 25.07,
  ry: 32.81,
  transform: "rotate(-13.72 8.291 861.915)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 274.8,
  cy: 554.86,
  rx: 25.07,
  ry: 32.81,
  transform: "rotate(-13.72 -1.188 822.954)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M229.38 208.22a118.65 118.65 0 005.81-15.56l-66.55 5.11 69.33-16.38a120.32 120.32 0 00-20.33-93l-81.09 70.83 70.26-83.83A120.07 120.07 0 1046.02 252.94a119.33 119.33 0 00-8.11 24.52l93.59 22.88-95.82-8.12a120.14 120.14 0 0045.54 105 120.07 120.07 0 10183.37-44.75 120.08 120.08 0 00-35.21-144.25z",
  fill: "#3fa7f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.66 331.16a119.51 119.51 0 0042.56 66 120.07 120.07 0 10183.37-44.75c10.79-23.64-229.09-34.34-225.93-21.25z",
  opacity: 0.1
}));

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 532,
  cy: 711.44,
  rx: 525,
  ry: 73,
  fill: "#3fa7f5",
  opacity: 0.1
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 138,
  width: 568,
  height: 684,
  rx: 19.8,
  fill: "#464353"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#3fa7f5",
  opacity: 0.1,
  d: "M187 69h470v546H187z"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 422,
  cy: 651,
  r: 20,
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 422,
  cy: 40,
  r: 9.5,
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M422 31a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10zM322 459.89v-18.07h2.06v8.67l9.16-8.48a.79.79 0 01.52-.19.86.86 0 01.87.87v16.33a.86.86 0 01-.87.87.8.8 0 01-.54-.21l-9.14-8.41v8.62z",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M333.74 442.31a.36.36 0 01.37.37v16.34a.37.37 0 01-.58.29l-8.3-7.63-.87-.81.88-.8 8.29-7.68a.37.37 0 01.21-.08m-10.18 0v17.07h-1.06v-17.07h1.07m10.18-1a1.33 1.33 0 00-.86.32l-8.32 7.7v-7.51a.51.51 0 00-.51-.51H322a.51.51 0 00-.51.51v18a.51.51 0 00.51.51h2.05a.51.51 0 00.51-.51v-7.46l8.32 7.66a1.32 1.32 0 00.86.31 1.35 1.35 0 001.37-1.36v-16.29a1.36 1.36 0 00-1.37-1.37zM519.96 459.89v-8.67l-9.16 8.48a.82.82 0 01-.53.19.86.86 0 01-.6-.25.82.82 0 01-.27-.62v-16.34a.87.87 0 011.42-.67l9.14 8.42v-8.61h2v18.06z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M510.26 442.31a.32.32 0 01.21.08l8.3 7.63.87.8-.87.81-8.3 7.68a.31.31 0 01-.21.07.36.36 0 01-.37-.36v-16.34a.37.37 0 01.37-.37m11.26 0v17.07h-1.02v-17.07h1m-11.26-1a1.36 1.36 0 00-1.37 1.37v16.34a1.36 1.36 0 001.37 1.36 1.33 1.33 0 00.87-.31l8.32-7.71v7.51a.51.51 0 00.51.51h2a.51.51 0 00.52-.51v-18a.51.51 0 00-.52-.51h-2a.51.51 0 00-.51.51v7.47l-8.32-7.66a1.34 1.34 0 00-.87-.32zM425.4 460.22a1.54 1.54 0 01-1.54-1.54v-14.96a1.54 1.54 0 011.54-1.5h4.1a1.54 1.54 0 011.54 1.54v14.93a1.54 1.54 0 01-1.54 1.53zm-10.9 0a1.54 1.54 0 01-1.54-1.54v-14.96a1.54 1.54 0 011.54-1.5h4.07a1.54 1.54 0 011.54 1.54v14.93a1.54 1.54 0 01-1.54 1.54z",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M429.5 442.68a1 1 0 011 1v14.94a1 1 0 01-1 1h-4.1a1 1 0 01-1-1v-14.91a1 1 0 011-1h4.1m-10.86 0a1 1 0 011 1v14.94a1 1 0 01-1 1h-4.14a1 1 0 01-1-1v-14.94a1 1 0 011-1h4.07m10.86-1h-4.03a2 2 0 00-2 2v14.94a2 2 0 002 2h4.1a2 2 0 002-2v-14.94a2 2 0 00-2-2zm-10.86 0h-4.07a2 2 0 00-2 2v14.94a2 2 0 002 2h4.07a2 2 0 002-2v-14.94a2 2 0 00-2-2z",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#3fa7f5",
  opacity: 0.5,
  d: "M302 417.49h240v2.67H302z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M376.11 424.66a5.84 5.84 0 115.83-5.84 5.84 5.84 0 01-5.83 5.84z",
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M376.11 413.49a5.34 5.34 0 11-5.33 5.33 5.33 5.33 0 015.33-5.33m0-1a6.34 6.34 0 106.33 6.33 6.33 6.33 0 00-6.33-6.33z",
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M302.5 417.99h73.11v1.67H302.5z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M375.11 418.49v.67H303v-.67h72.11m1-1H302v2.67h74.11v-2.67z",
  fill: "#fff"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 311,
  cy: 210.44,
  r: 46,
  fill: "#3fa7f5"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 533,
  cy: 210.44,
  r: 46,
  fill: "#3fa7f5"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 328,
  cy: 189.44,
  r: 7,
  fill: "#fff"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 556,
  cy: 189.44,
  r: 7,
  fill: "#fff"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M543 303.44c0 8.83-54.17 32-121 32s-121-23.17-121-32 54.17 0 121 0 121-8.84 121 0z",
  fill: "#fff"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M781.31 157.37h-.17a19.23 19.23 0 00-16.07 8.8 19.25 19.25 0 00-16.07-8.8h-.17a19.12 19.12 0 00-19 19.12c0 6.26 2.74 15.14 8.09 22.45 10.18 13.92 27.1 26.1 27.1 26.1s16.92-12.18 27.1-26.1c5.35-7.31 8.09-16.19 8.09-22.45a19.13 19.13 0 00-18.9-19.12zM839.57 90.64h-.13a14.78 14.78 0 00-12.33 6.75 14.78 14.78 0 00-12.33-6.75h-.13a14.68 14.68 0 00-14.54 14.67c0 4.8 2.11 11.62 6.21 17.22 7.81 10.68 20.79 20 20.79 20s13-9.35 20.79-20c4.1-5.6 6.2-12.42 6.2-17.22a14.68 14.68 0 00-14.53-14.67zM907.5 165.56h-.13a14.76 14.76 0 00-12.32 6.75 14.79 14.79 0 00-12.33-6.75h-.13a14.68 14.68 0 00-14.58 14.66c0 4.8 2.1 11.61 6.2 17.22 7.82 10.68 20.8 20 20.8 20s13-9.35 20.79-20c4.1-5.61 6.2-12.42 6.2-17.22a14.68 14.68 0 00-14.5-14.66z",
  fill: "#f86d70"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M1070.33 544.82l.79-.54a40.58 40.58 0 01-11.26 1.7 49.32 49.32 0 01-18.82-4.1c-9.79-4.23-18.19-11.28-25.06-19.45-9.5-11.3-16.68-25.22-29.35-32.77a22.81 22.81 0 00-8.57-3.24c-5.36-.69-10.63 1.35-15.83 2.84-22.47 6.46-49.08 1.73-64.58-15.8-3.28-3.7-6-7.88-9.64-11.26-12-11.2-31.16-10.91-46.34-4.69-.92.37-1.83.78-2.72 1.22a6.23 6.23 0 01.15-.62 17.45 17.45 0 00-7.14 5.14c-2.82 3.77-2.82 8.66-2.07 13.11a13.92 13.92 0 001.14 4.15 12.25 12.25 0 00-2.89 7.91c0 .36 0 .71.05 1.06A44.12 44.12 0 00794 527.59v-.29a44.91 44.91 0 00-.25 4.67v.59a44 44 0 0013.61 31.88 32.81 32.81 0 0013 16.37c-.12.5-.24 1-.38 1.51-2.27 8.24-7.57 16.94-19.46 20.8-.5.17-1 .32-1.54.47l-2.46.69-1 .3c-24.58 7.13-31.61 12.89-33.84 22.39-1.84 7.82-4 21.8-4.89 27.4-1.78 4.12-13.88 32.75-12.92 49.3.16 2.85.24 5.7.19 8.56-.11 5.79 1.55 15.12 13.83 12.66 7-1.4 18-4.75 28.84-8.28q-.95 2.91-2.14 5.73c-1.61 3.81-3.56 7.78-4.57 11.78v.11l-.12.49v.29c0 .1-.07.34-.11.51s0 .09 0 .14a1.29 1.29 0 010 .19c0 .22-.07.43-.1.65s-.08.57-.11.86v.54a2.46 2.46 0 010 .26v1.3a2.71 2.71 0 010 .29c0 .26 0 .52.05.78v.1c0 .03 0 .33.06.49s0 .26 0 .39v.18l.09.46c0 .11 0 .23.07.34l.12.47c0 .15.08.29.13.44a16.27 16.27 0 011.06 3.72 6.52 6.52 0 01-.23 2.11l-.15.54a.56.56 0 010 .12c-.11.38-.24.76-.37 1.14-.07.21-.14.42-.2.63 0 .06 0 .12-.07.19l-.06.2-.06.21v.09l-.15.61v.18a1.85 1.85 0 000 .23v.15a2.89 2.89 0 000 .29 1.11 1.11 0 010 .19v.09a4.7 4.7 0 000 .53 10.23 10.23 0 001.67 4.55c.19.33.4.65.59 1l-42-.69a36.2 36.2 0 00-24.25 8.62c-12.07 10.4-7.42 20.54 2.16 28.83 10.4 9 26.62 15.85 33.46 18.48 2 .79 3.22 1.2 3.22 1.2h103l1.53.35a71 71 0 0014.27 1.23 149.08 149.08 0 0017.42-1c1.74-.2 3.5-.43 5.26-.62h11l1 .19c5.11 1.09 10.45 3.9 15.24 1.81a5.5 5.5 0 002.44-2h12.29c22.77 0 35.84-7.53 42.21-17.87 4.57-7.41 5.69-16.26 4.47-24.8-2.48-17.37-63.41-17.89-81.75-17.65-.26-.24-.53-.46-.8-.67-2.11-1.66-4.66-3.39-4.93-6.08-.15-1.61.59-3.22.34-4.82-.45-2.78-3.52-4.13-5.91-5.6-8.17-5-11.34-15.61-10.54-25.15.06-.61.12-1.23.2-1.84.06-.48.14-.95.21-1.42a1.87 1.87 0 010-.25v-.09a279.81 279.81 0 0028.46 7.47c36.18 7.6 26.84-10.53 26.84-10.53s-4.08-25.72-6.42-35.66-14-36.24-14-36.24l-.3-.69c-.09-3.23-1.35-25.67-18.66-30-5.16-1.3-10.72-2.38-16.07-3.76l-.38-.11c-1.79-.46-3.55-1-5.26-1.52-9.48-3.07-17.36-7.75-19.49-17.19-.11-.51-.21-1-.29-1.57a32.78 32.78 0 0013-17 44 44 0 0012.74-31 2.71 2.71 0 000-.29v-.3a42.31 42.31 0 00-.25-4.67v.29a44 44 0 00-2.24-9.77 46 46 0 0011.16 7.44 36 36 0 0015.49 3.21 35.5 35.5 0 0010.2-1.32c8.13-2.31 15.41-7.47 23.78-8.64a28.71 28.71 0 013.19-.24c8.33.17 16.47 3.93 23.93 8a276.12 276.12 0 0128.06 17.36c8.87 6.25 17.81 13.22 28.47 15.22a36.27 36.27 0 007.2.59 55.9 55.9 0 0019.63-3.76 93.25 93.25 0 0021.79-11.32c-.61.15-1.25.33-1.92.49zm-216-53.16c-.63-.26-1.28-.51-1.93-.74q.08-.39.12-.78c.61.49 1.21 1 1.8 1.52zm-81.92 205.17s7.37-20.61 7.41-25.74l4.56-13.09 1.69 2.7c-.15.9-.29 1.8-.43 2.7s-.26 1.68-.37 2.52c-.12.86-.22 1.71-.29 2.57 0 .24 0 .48-.05.72V671.78a2.09 2.09 0 000 .25v.35c0 .33.05.66.08 1v.2a1 1 0 010 .17c0 .35.1.7.17 1s.16.73.25 1.1v.11c.88 3.25 2.81 6.11 3.86 9.31.09.29.18.59.26.88l.09.36.15.62.09.45.12.66v.27c0 .32.09.64.13.95a39.28 39.28 0 01.2 5.53c0 .57 0 1.13-.06 1.7-7.89 1.31-15.27 1.77-17.86.14zm119.82-38.27c1.83 7.61 12.64 32.42 12.64 32.42-2 1.51-9.48 1.18-17.38.32.15-.38.29-.75.43-1.13l.22-.6.39-1c.24-.67.49-1.33.73-2l.45-1.32v-.17c.15-.46.29-.92.42-1.39.06-.18.11-.37.16-.56v-.06l.23-.89c0-.15.07-.29.11-.44l.18-.76c0-.11 0-.22.07-.34a2 2 0 000-.24c0-.13.06-.26.08-.38.07-.31.13-.63.18-.94a2.74 2.74 0 000-.28 1 1 0 000-.17c0-.22.08-.45.11-.68q.15-1 .27-1.95v-.4a5.42 5.42 0 00.06-.58v-.95c0-.24 0-.48.05-.72s0-.32 0-.48a.92.92 0 000-.16v-2.47-.64-.83a.25.25 0 000-.08v-.58-.08-.24c0-.48-.06-1-.1-1.45v-.48a44.78 44.78 0 00-.64-4.44z",
  transform: "translate(-71.5 -57.78)",
  fill: "url(#meditating_svg__a)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M843.23 579.06l-23.17 21.43-1.72 4.49-1.17 3-97.9 4.64-5.26-8.34-1.69-2.67-4.63 13.32-23.19-14.44s2.89-19.69 5.21-29.54c2.21-9.41 9.19-15.12 33.6-22.18l1-.31 2.44-.68c.52-.14 1-.29 1.53-.46 11.8-3.83 17.06-12.45 19.31-20.61a47.74 47.74 0 001.17-18.32s35.63-11.29 34.47 11.3a25.47 25.47 0 00.52 6.88c2.12 9.35 9.94 14 19.35 17q2.55.82 5.22 1.51l.38.1c5.31 1.37 10.83 2.45 16 3.73 18.53 4.66 18.53 30.15 18.53 30.15z",
  fill: "#db8b8b"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M760.72 408.72c2.06-2.75 5.28-4.38 8.47-5.68 15.08-6.16 34.09-6.45 46 4.65 3.59 3.34 6.31 7.49 9.57 11.16 15.39 17.37 41.8 22.05 64.11 15.65 5.16-1.48 10.4-3.5 15.72-2.81a22.5 22.5 0 018.5 3.21c12.58 7.48 19.71 21.27 29.14 32.47 6.81 8.09 15.16 15.07 24.88 19.27s20.88 5.44 31 2.38a92.85 92.85 0 01-21.61 11.2c-8.14 2.94-17 4.73-25.47 3.13-10.59-2-19.46-8.89-28.27-15.08a273.43 273.43 0 00-27.85-17.19c-8.69-4.68-18.3-9-28.08-7.64-8.31 1.15-15.53 6.27-23.61 8.55a36 36 0 01-24.43-1.77c-20.67-9.4-30.13-37.12-52.26-42.23-5.66-1.3-6.7.7-7.86-6.23-.75-4.46-.76-9.29 2.05-13.04z",
  fill: "#35323e"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M984.32 491.22c-8.14 2.94-17 4.73-25.47 3.13-10.59-2-19.46-8.88-28.27-15.08a273.43 273.43 0 00-27.85-17.19c-8.69-4.68-18.3-9-28.08-7.64-8.31 1.15-15.53 6.27-23.61 8.56a36 36 0 01-24.43-1.78c-20.67-9.4-30.13-37.12-52.26-42.22-5.66-1.31-6.7.69-7.87-6.24a21.15 21.15 0 01.16-9.1 17.33 17.33 0 00-7.08 5.1c-2.81 3.74-2.8 8.57-2 13 1.17 6.93 2.2 4.93 7.86 6.23 22.13 5.11 31.59 32.83 52.26 42.23a36 36 0 0024.43 1.84c8.08-2.28 15.3-7.4 23.61-8.55 9.78-1.36 19.39 3 28.08 7.64a274.67 274.67 0 0127.86 17.19c8.81 6.19 17.68 13.1 28.26 15.08 8.51 1.6 17.33-.19 25.47-3.13a92.85 92.85 0 0021.64-11.22 40.51 40.51 0 01-11.2 1.68z",
  opacity: 0.1
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 765.32,
  cy: 477.4,
  r: 43.73,
  fill: "#35323e"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M765.32 511.29a43.74 43.74 0 01-43.48-39.07 44.29 44.29 0 00-.25 4.63 43.74 43.74 0 1087.47 0 44.29 44.29 0 00-.25-4.63 43.74 43.74 0 01-43.49 39.07z",
  opacity: 0.1
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M783.8 526.57a32.47 32.47 0 01-36.16.14 47.74 47.74 0 001.17-18.32s35.63-11.29 34.47 11.3a25.47 25.47 0 00.52 6.88z",
  opacity: 0.1
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 765.61,
  cy: 497.96,
  r: 32.44,
  fill: "#db8b8b"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M761.09 586.48a25 25 0 014 5.66c1.69 3.32 2.62 7.35 1.11 10.77a15.32 15.32 0 012.18-12.57 23.47 23.47 0 0110.12-8.12",
  opacity: 0.05
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M906.85 741.22c-6.32 10.24-19.29 17.71-41.89 17.71H682.5s-1.19-.41-3.19-1.19c-6.79-2.61-22.89-9.39-33.22-18.32-9.5-8.21-14.13-18.25-2.14-28.57a36 36 0 0124.07-8.53l61.4 1 95.57-4.1s83.41-2.9 86.31 17.37c1.2 8.51.09 17.28-4.45 24.63z",
  fill: "#35323e"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M832.5 705.22c-1 2.18-3.7 2.7-6 3.37-9.46 2.77-15.3 12-22.84 18.31a43.66 43.66 0 01-12.77 7.45c-10.56 4-22.33 3.63-33.3 1.07s-23.45-4.72-31.7-12.4a91 91 0 01-16.77-21 10 10 0 01-1.66-4.51 4.52 4.52 0 010-.52 1.53 1.53 0 010-.3 1.43 1.43 0 010-.29c0-.13 0-.26.07-.38a3 3 0 01.1-.43c0-.15.07-.29.11-.44s.09-.28.13-.42c.2-.66.44-1.3.64-2 .07-.22.13-.44.18-.65a6.4 6.4 0 00.23-2.09 16.82 16.82 0 00-1.05-3.69c0-.14-.09-.29-.13-.43s-.09-.33-.13-.49c-.07-.32-.14-.64-.2-1s-.09-.65-.12-1a14.41 14.41 0 01-.07-1.46v-.8a.14.14 0 010-.09c0-.27 0-.53.05-.79.06-.56.14-1.13.25-1.69 0-.31.11-.61.18-.93q.06-.22.12-.48a.45.45 0 010-.11c1-4 2.94-7.89 4.54-11.68a74.36 74.36 0 005.83-27 38.43 38.43 0 00-.2-5.47c0-.2-.05-.39-.07-.59s-.09-.64-.16-1-.13-.7-.21-1-.11-.44-.18-.66-.16-.58-.25-.87c-1-3.18-3-6-3.85-9.26q-.15-.6-.27-1.2c-.07-.35-.13-.69-.17-1v-.37c-.06-.52-.09-1-.1-1.57v-.69-.78c0-.26 0-.71.05-1.07s0-.48 0-.72c0-.44.08-.87.14-1.29s.1-.86.16-1.29c.11-.83.24-1.67.37-2.5s.28-1.79.43-2.68c.7-4.09 1.63-8.17 3.73-11.72 3.08-5.19 8.59-9.2 9.54-15.16a19.54 19.54 0 00-.55-7.12c-.12-.52-.23-1-.34-1.55a151.88 151.88 0 01-3.06-20l1-.31 2.44-.68c.52-.14 1-.29 1.53-.46a126.55 126.55 0 002.65 20c1.1 5.14 2.55 10.3 5.3 14.8s6.92 8.3 12 9.65c3.37.9 6.94.68 10.42.38 7-.61 13.95-1.57 20.84-2.86 5-1 10.07-2.09 14.55-4.54a10 10 0 003.11-2.39 11.87 11.87 0 001.95-4.57 125.87 125.87 0 004-34.24q2.55.82 5.22 1.51l.38.1c0 1.89-.09 3.77-.18 5.65-.05 1.14-.12 2.28-.19 3.43 0 .64-.09 1.29-.15 1.93 0 .46-.09.93-.13 1.39 0 .14 0 .28-.05.42-.06.56-.12 1.12-.19 1.67-.09.75-.2 1.5-.31 2.25l-.15 1c-.21 1.44-.43 2.89-.61 4.34a41.69 41.69 0 00-.37 6.5c.16 4.74 2.82 9.42 5.66 13.22 3.41 4.57 4.3 9.66 5.67 15.19.22.91.42 1.83.59 2.75.28 1.46.49 2.93.63 4.4 0 .28 0 .56.07.84s0 .42 0 .62v6.25c0 .24 0 .59-.07.9s0 .36 0 .53l-.06.58c0 .29-.07.59-.11.88s-.09.71-.14 1.06-.11.71-.17 1.06c-.11.66-.24 1.33-.39 2-.18.83-.38 1.65-.61 2.47-.06.25-.13.49-.2.73-.26.9-.55 1.79-.87 2.68-1.13 3.13-2.35 6.26-3.5 9.4-.19.52-.38 1-.56 1.57s-.37 1-.54 1.55c-.18.53-.35 1.06-.53 1.58s-.33 1-.49 1.58c-.33 1.08-.63 2.16-.91 3.25-.08.32-.17.64-.24 1 0 .14-.07.3-.1.44s-.07.29-.1.44c-.15.68-.29 1.36-.42 2.05l-.15.86c-.09.57-.17 1.13-.25 1.69-.08.6-.14 1.22-.2 1.83-.8 9.45 2.35 20 10.46 24.92 2.38 1.45 5.42 2.79 5.87 5.54.25 1.59-.49 3.18-.33 4.78.26 2.66 2.79 4.38 4.89 6 2.34 1.72 4.34 4.38 3.34 6.82z",
  fill: "#3fa7f5"
});

var _ref35 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M808.5 647.93a33.74 33.74 0 00.19 7.44c1.12-8.77 4.8-17 7.8-25.4a47.39 47.39 0 002.53-20.59 46.8 46.8 0 01-2.53 11.32c-3.26 8.93-7.24 17.77-7.99 27.23zM808.75 545.22c0 1.89-.09 3.77-.18 5.65-.05 1.14-.11 2.28-.19 3.43 0 .64-.09 1.29-.15 1.93 0 .46-.09.93-.13 1.39 0 .14 0 .28-.05.42-.06.56-.12 1.12-.19 1.67-.09.75-.2 1.5-.31 2.25l-.15 1c-.21 1.44-.43 2.89-.61 4.34a14.52 14.52 0 01-.37-2.77c-.16-4.73.85-9.41 1.44-14.12.22-1.76.39-3.54.51-5.32zM717.24 628.78a21 21 0 01.87 4.15c.1-1.26.17-2.53.2-3.79a28.6 28.6 0 00-1.07-9.63c-1-3.18-3-6-3.85-9.25-.06-.26-.13-.51-.18-.76a25.2 25.2 0 00.18 10c.88 3.25 2.81 6.1 3.85 9.28zM829.35 698.48c-.93.34-1.93.59-2.85.86-9.46 2.77-15.3 12-22.84 18.31a43.69 43.69 0 01-12.77 7.46c-10.56 3.94-22.33 3.62-33.3 1.06s-23.45-4.72-31.7-12.39a91.55 91.55 0 01-16.77-21l-.35-.62c-.45 1.79-1.36 3.54-1.3 5.38a9.89 9.89 0 001.65 4.51 91.28 91.28 0 0016.77 21c8.25 7.68 20.73 9.84 31.7 12.4s22.74 2.88 33.3-1.07a43.44 43.44 0 0012.77-7.45c7.54-6.35 13.38-15.54 22.84-18.31 2.28-.67 5-1.19 6-3.37 1-2.47-1-5.12-3.15-6.77zM708.98 680.76a15.86 15.86 0 00-1-3.64 16.81 16.81 0 00-.14 8.79c.45-1.69 1.26-3.39 1.14-5.15zM727.28 568.22a12.54 12.54 0 01-.55 2.15c-.12-.52-.23-1-.34-1.55a151.88 151.88 0 01-3.06-20l1-.31q.81 5.57 2 11c.69 2.85 1.41 5.78.95 8.71z"
}));

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M691.76 592.67l-6.66 4.93s-14.08 31.62-13.05 49.35c.16 2.82.24 5.65.19 8.48-.11 5.74 1.54 15 13.73 12.55 17.37-3.48 60.24-19.12 60.24-19.12l-2.9-13.9s-36.49 9.26-42.81 5.26c0 0 8.4-23.46 7.24-26.35s-15.98-21.2-15.98-21.2zM839.5 570.08l4 9.27s11.59 26.07 13.9 35.91 6.38 35.34 6.38 35.34 9.26 18-26.65 10.42-51-16.79-51-16.79l7-12.75s34.17 6.37 38.81 2.9c0 0-13.9-31.86-12.75-34.18s20.31-30.12 20.31-30.12z",
  fill: "#db8b8b"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M737.5 639.01l5.79-5.21s11-51 20.86-43.44-4.06 51-4.06 51l-13.9 7.53z",
  fill: "#db8b8b"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M796.6 635.54l-3.47-4.06s-12.17-50.39-22.59-41.7 10.96 50.44 10.96 50.44l4.64 4.06 9.26-2.32zM820.35 728.8s-43.51 4.54-47.24 7.19-1.41 18.87-1.41 18.87l57.34-3.47z",
  fill: "#db8b8b"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M820.35 728.8s-43.51 4.54-47.24 7.19-1.41 18.87-1.41 18.87l57.34-3.47z",
  opacity: 0.1
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M894.79 741.83c-6.32 10.24-8.39 15.93-31 15.93h-49.81v-30.12l6.37-3.48c27.23-12.16 57.35-8.11 57.35-8.11z",
  opacity: 0.1
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M906.85 741.22c-6.32 10.24-19.29 17.71-41.89 17.71h-49.82V728.8l6.36-3.48c27.23-12.16 57.35-8.11 57.35-8.11z",
  fill: "#35323e"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M799.32 733.99c2-.52 4.15-1.13 6.23-.8a8.84 8.84 0 016 4.32 7.71 7.71 0 001.74 2.38 5.53 5.53 0 002.84.81c6.85.65 13.83.64 20.49 2.39s13.19 5.62 16.09 11.87a5.27 5.27 0 01.6 2.29 4.54 4.54 0 01-3 3.65c-4.75 2.07-10.06-.71-15.13-1.8-5.72-1.23-11.64-.23-17.46.43a149 149 0 01-17.29 1 70.78 70.78 0 01-14.15-1.31c-2.61-.55-5.18-1.32-7.82-1.67a53.27 53.27 0 00-7.58-.28q-17.57.2-35.1-.53c-3.71-.15-7.49-.34-10.94-1.7a3.46 3.46 0 01-1.86-1.34 3.51 3.51 0 01-.37-1.63 33.11 33.11 0 013.32-16.4c.81-1.67 2.4-5.55 4.2-6.37s6.54 1.17 8.55 1.62c12.79 2.9 25.8 5.39 39 5.48a86.49 86.49 0 0021.64-2.41z",
  fill: "#db8b8b"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M734.62 727.06l-7.74 30.16-47.58-1.19c-6.79-2.61 10.33-9.87 0-18.79l-12.45-28.72s15.64 2.32 26.07 6.38 16.8 3.47 16.8 3.47 22.59 5.79 24.9 8.69z",
  opacity: 0.1
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M734.62 728.8l-7.74 30.12-47.58-1.19c-6.79-2.61-22.89-9.39-33.22-18.32l20.77-29.19s15.64 2.32 26.07 6.37 16.8 3.48 16.8 3.48 22.59 5.83 24.9 8.73z",
  fill: "#35323e"
});

var _ref45 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 836.88,
  cy: 526.93,
  rx: 16.8,
  ry: 34.7,
  transform: "rotate(-83.23 768.619 538.274)",
  fill: "#35323e"
});

var _ref46 = /*#__PURE__*/React.createElement("circle", {
  cx: 767.93,
  cy: 433.67,
  r: 12.16,
  fill: "#35323e"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M755.77 433.67s15.25-2.94 22.68 2-22.68-2-22.68-2z",
  opacity: 0.1
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M809 472.09c0 1-.67 2.17-3 .13-5.88-5.13-19.41-18.65-38-18.65-19.38 0-35.09 13.87-42 18.65-2.34 1.62-4 .74-4-.13 0-3.41 20-30.87 46-30.87s41 27.46 41 30.87z",
  fill: "#3fa7f5"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M807.86 468.81c-.3.65-1.12.93-2.86-.59-5.88-5.13-19.41-18.65-38-18.65-19.38 0-35.09 13.87-42 18.65a5.25 5.25 0 01-1.63.79 8.3 8.3 0 00-1.37 3.08c0 .87 1.66 1.75 4 .13 6.91-4.78 22.62-18.65 42-18.65 18.59 0 32.12 13.52 38 18.65 2.33 2 3 .84 3-.13a10.18 10.18 0 00-1.14-3.28z",
  opacity: 0.1
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  fill: "#6a5c99",
  d: "M806.11 471.96h3.27v18.51h-3.27z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M801.75 483.93A11.25 11.25 0 01813 495.18v.73a11.25 11.25 0 01-11.25 11.25v-23.23z",
  fill: "#3fa7f5"
});

var _ref52 = /*#__PURE__*/React.createElement("rect", {
  x: 799.57,
  y: 482.84,
  width: 5.08,
  height: 25.4,
  rx: 2.54,
  fill: "#6a5c99"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  fill: "#6a5c99",
  d: "M725.28 490.83h-3.27v-18.51h3.27z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M729.64 507.52a11.25 11.25 0 01-11.25-11.25v-.73a11.25 11.25 0 0111.25-11.25v23.23z",
  fill: "#3fa7f5"
});

var _ref55 = /*#__PURE__*/React.createElement("rect", {
  x: 798.23,
  y: 540.99,
  width: 5.08,
  height: 25.4,
  rx: 2.54,
  transform: "rotate(-180 765.02 524.8)",
  fill: "#6a5c99"
});

var _ref56 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 974.2,
  cy: 709.38,
  rx: 33.8,
  ry: 6.5,
  fill: "#3fa7f5"
});

var _ref57 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 973.63,
  cy: 706.62,
  rx: 3.94,
  ry: 5.15,
  fill: "#3f3d56"
});

var _ref58 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 973.63,
  cy: 700.32,
  rx: 3.94,
  ry: 5.15,
  fill: "#3f3d56"
});

var _ref59 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 973.63,
  cy: 694.03,
  rx: 3.94,
  ry: 5.15,
  fill: "#3f3d56"
});

var _ref60 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 973.63,
  cy: 687.73,
  rx: 3.94,
  ry: 5.15,
  fill: "#3f3d56"
});

var _ref61 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 973.63,
  cy: 681.43,
  rx: 3.94,
  ry: 5.15,
  fill: "#3f3d56"
});

var _ref62 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 973.63,
  cy: 675.14,
  rx: 3.94,
  ry: 5.15,
  fill: "#3f3d56"
});

var _ref63 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 973.63,
  cy: 668.84,
  rx: 3.94,
  ry: 5.15,
  fill: "#3f3d56"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M988.37 625.75a19.81 19.81 0 001.46-2.15l-10.34-1.7 11.18.08a18.82 18.82 0 00.36-14.93l-15 7.78 13.84-10.17a18.85 18.85 0 10-31.14 21.09 19.65 19.65 0 00-2.15 3.44l13.43 7-14.32-4.8a18.89 18.89 0 003 17.7 18.85 18.85 0 1029.64 0 18.87 18.87 0 000-23.31z",
  fill: "#3fa7f5"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M954.7 637.41a18.78 18.78 0 004 11.65 18.85 18.85 0 1029.64 0c2.55-3.2-33.64-13.77-33.64-11.65z",
  opacity: 0.1
});

function SvgMeditating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 1057 784.44"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65);
}

export default __webpack_public_path__ + "static/meditating.5e2b2adc.svg";
export { SvgMeditating as ReactComponent };